import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AccountEntry from './components/Login/AccountEntry';
import LoginPage from './components/Login/LoginPage';
import Dashboard from './components/pages/Dashboard';
import SideBar from './components/layouts/SideBar';
import City from './components/pages/Master/City/City';
import AddCity from './components/pages/Master/City/AddCity';
import EditCity from './components/pages/Master/City/EditCity';
import State from './components/pages/Master/State/State';
import AddState from './components/pages/Master/State/AddState';
import EditState from './components/pages/Master/State/EditState';
import Country from './components/pages/Master/Country/Country';
import AddCountry from './components/pages/Master/Country/AddCountry';
import EditCountry from './components/pages/Master/Country/EditCountry';
import Department from './components/pages/Master/Department/Department';
import AddDepartment from './components/pages/Master/Department/AddDepartment';
import EditDepartment from './components/pages/Master/Department/EditDepartment';
import Designation from './components/pages/Master/Designation/Designation';
import AddDesignation from './components/pages/Master/Designation/AddDesignation';
import EditDesignation from './components/pages/Master/Designation/EditDesignation';
import Employee from './components/pages/Master/Employee/Employee';
import AddEmployee from './components/pages/Master/Employee/AddEmployee';
import FollowUpMedium from './components/pages/Master/Follow Up Medium/FollowUpMedium';
import AddFollowUpMedium from './components/pages/Master/Follow Up Medium/AddFollowUpMedium';
import EditFollowUpMedium from './components/pages/Master/Follow Up Medium/EditFollowUpMedium';
import InterestLevel from './components/pages/Master/Interest Level/InterestLevel';
import AddInterestLevel from './components/pages/Master/Interest Level/AddInterestLevel';
import EditInterestLevel from './components/pages/Master/Interest Level/EditInterestLevel';
import Organization from './components/pages/Master/Organization/Organization';
import EditOrganization from './components/pages/Master/Organization/EditOrganization';
import EditEmployee from './components/pages/Master/Employee/EditEmployee';
import Source from './components/pages/Master/Source/Source';
import AddSource from './components/pages/Master/Source/AddSource';
import EditSource from './components/pages/Master/Source/EditSource';
import Status from './components/pages/Master/Status/Status';
import AddStatus from './components/pages/Master/Status/AddStatus';
import EditStatus from './components/pages/Master/Status/EditStatus';
import Nationality from './components/pages/Master/Nationality/Nationality';
import AddNationality from './components/pages/Master/Nationality/AddNationality';
import EditNationality from './components/pages/Master/Nationality/EditNationality';
import Branch from './components/pages/Master/Branch/Branch';
import EditBranch from './components/pages/Master/Branch/EditBranch';
import User from './components/pages/C-Panel/User/User';
import AddUser from './components/pages/C-Panel/User/AddUser';
import EditUser from './components/pages/C-Panel/User/EditUser';
import Course from './components/pages/Course/Course/Course';
import AddCourse from './components/pages/Course/Course/AddCourse';
import EditCourse from './components/pages/Course/Course/EditCourse';
import Module from './components/pages/Course/Module/Module';
import Addmodule from './components/pages/Course/Module/AddModule';
import EditModule from './components/pages/Course/Module/EditModule';
import Topic from './components/pages/Course/Topic/Topic';
import AddTopic from './components/pages/Course/Topic/AddTopic';
import EditTopic from './components/pages/Course/Topic/EditTopic';
import Enquiry from './components/pages/Enquiry/Enquiry/Enquiry';
import AddEnquiry from './components/pages/Enquiry/Enquiry/AddEnquiry';
import EditEnquiry from './components/pages/Enquiry/Enquiry/EditEnquiry';
import Batch from './components/pages/Admission/Batch/Batch';
import EditBatch from './components/pages/Admission/Batch/EditBatch';
import AddBatch from './components/pages/Admission/Batch/AddBatch';
import Registration from './components/pages/Admission/Registration/Registration';
import AddRegistration from './components/pages/Admission/Registration/AddRegistration';
import EditRegistration from './components/pages/Admission/Registration/EditRegistration';
import Admission from './components/pages/Admission/Admission/Admission';
import AddAdmission from './components/pages/Admission/Admission/AddAdmission';
import EditAdmission from './components/pages/Admission/Admission/EditAdmission';
import StudentList from './components/pages/Admission/Student List/StudentList';
import ViewStudentList from './components/pages/Admission/Student List/ViewStudentList';
import ViewAssignment from './components/pages/Assignment/View Assignment/ViewAssignment';
import Assignment from './components/pages/Assignment/Assignment/Assignment';
import Question from './components/pages/Online Quiz/Question/Question';
import AddQuestion from './components/pages/Online Quiz/Question/AddQuestion';
import EditQuestion from './components/pages/Online Quiz/Question/EditQuestion';
import ManageCourseQuiz from './components/pages/Online Quiz/Mange Course Quiz/ManageCourseQuiz';
import AddManageCourseQuiz from './components/pages/Online Quiz/Mange Course Quiz/AddManageCourseQuiz';
import EditManageCourseQuiz from './components/pages/Online Quiz/Mange Course Quiz/EditManageCourseQuiz';
import ManageModuleQuiz from './components/pages/Online Quiz/Manage Module Quiz/ManageModuleQuiz';
import AddManageModuleQuiz from './components/pages/Online Quiz/Manage Module Quiz/AddManageModuleQuiz';
import EditManageModuleQuiz from './components/pages/Online Quiz/Manage Module Quiz/EditManageModuleQuiz';
import ManageTopicQuiz from './components/pages/Online Quiz/Manage Topic Quiz/ManageTopicQuiz';
import AddManageTopicQuiz from './components/pages/Online Quiz/Manage Topic Quiz/AddManageTopicQuiz';
import EditManageTopicQuiz from './components/pages/Online Quiz/Manage Topic Quiz/EditManageTopicQuiz';
import QuizResult from './components/pages/Online Quiz/Quiz Result/QuizResult';
import CourseQuestionMap from './components/pages/Master/Course Question Map/CourseQuestionMap';
import CourseTracker from './components/pages/Course/Course Tracker/CourseTracker';
import CourseManage from './components/pages/Course/Course Manage/CourseManage';
import Attendance from './components/pages/Attendance/Attendance';
import AddAttendance from './components/pages/Attendance/AddAttendance'; // ← add this
import EditAttendance from './components/pages/Attendance/EditAttendance';
import DuesList from './components/pages/Payment/Dues List/DuesList';
import ModeOfDelivery from './components/pages/Master/Mode of Delivery/ModeOfDelivery';
import AddModeOfDelivery from './components/pages/Master/Mode of Delivery/AddModeOfDelivery';
import EditModeOfDelivery from './components/pages/Master/Mode of Delivery/EditModeOfDelivery';
import UserGroup from './components/pages/C-Panel/User Group/UserGroup';
import AddUserGroup from './components/pages/C-Panel/User Group/AddUserGroup';
import EditUserGroup from './components/pages/C-Panel/User Group/EditUserGroup';
import IdCard from './components/pages/Certificate/Id Card/IdCard';
import AddIdCard from './components/pages/Certificate/Id Card/AddIdCard';
import EditIdCard from './components/pages/Certificate/Id Card/EditIdCard';
import Certificate from './components/pages/Certificate/Certificate/Certificate';
import AddCertificate from './components/pages/Certificate/Certificate/AddCertificate';
import EditCertificate from './components/pages/Certificate/Certificate/EditCertificate';
import CertificateIssue from './components/pages/Certificate/Certificate Issue/CertificateIssue';
import AddCertificateIssue from './components/pages/Certificate/Certificate Issue/AddCertificateIssue';
import CouncellorPerformance from './components/pages/Councellor/Councellor Performance/CouncellorPerformance';
import EditCertificateIssue from './components/pages/Certificate/Certificate Issue/EditCertificateIssue';
import TrainerPerformance from './components/pages/Councellor/Trainer Performance/TrainerPerformance';
import SalesExecutivePerformance from './components/pages/Councellor/Sales Executive Performance/SalesExecutivePerformance';
import SalaryHeadType from './components/pages/Payroll/Salary Head Type/SalaryHeadType';
import AddSalaryHeadType from './components/pages/Payroll/Salary Head Type/AddSalaryHeadType';
import EditSalaryHeadType from './components/pages/Payroll/Salary Head Type/EditSalaryHeadType';
import SalaryHead from './components/pages/Payroll/Salary Head/SalaryHead';
import AddSalaryHead from './components/pages/Payroll/Salary Head/AddSalaryHead';
import EditSalaryHead from './components/pages/Payroll/Salary Head/EditSalaryHead';
import LeaveApply from './components/pages/Payroll/Leave Apply/LeaveApply';
import MainCategory from './components/pages/Inventory/Main Category/MainCategory';
import AddMainCategory from './components/pages/Inventory/Main Category/AddMainCategory';
import EditMainCategory from './components/pages/Inventory/Main Category/EditMainCategory';
import SubCategory from './components/pages/Inventory/Sub Category/SubCategory';
import AddSubCategory from './components/pages/Inventory/Sub Category/AddSubCategory';
import EditSubCategory from './components/pages/Inventory/Sub Category/EditSubCategory';
import Brand from './components/pages/Inventory/Brand/Brand';
import AddBrand from './components/pages/Inventory/Brand/AddBrand';
import EditBrand from './components/pages/Inventory/Brand/EditBrand';
import Characteristics from './components/pages/Inventory/Characteristics/Characteristics';
import AddCharacteristics from './components/pages/Inventory/Characteristics/AddCharacteristics';
import EditCharacteristics from './components/pages/Inventory/Characteristics/EditCharacteristics';
import ProductMaster from './components/pages/Inventory/Product Master/ProductMaster';
import AddProductMaster from './components/pages/Inventory/Product Master/AddProductMaster';
import EditProductMaster from './components/pages/Inventory/Product Master/EditProductMaster';
import ClientDetails from './components/pages/Enquiry/Client Details/ClientDetails';
import AddClientDetails from './components/pages/Enquiry/Client Details/AddClientDetails';
import EditClientDetails from './components/pages/Enquiry/Client Details/EditClientDetails';
import EnquiryQuotation from './components/pages/Enquiry/Enquiry Quotation/EnquiryQuotation';
import AddEnquiryQuotation from './components/pages/Enquiry/Enquiry Quotation/AddEnquiryQuotation';
import EditEnquiryQuotation from './components/pages/Enquiry/Enquiry Quotation/EditEnquiryQuotation';
import Customer from './components/pages/Accounting Master/Customer/Customer';
import AddCustomer from './components/pages/Accounting Master/Customer/AddCustomer';
import EditCustomer from './components/pages/Accounting Master/Customer/EditCustomer';
import Vendor from './components/pages/Accounting Master/Vendor/Vendor';
import AddVendor from './components/pages/Accounting Master/Vendor/AddVendor';
import EditVendor from './components/pages/Accounting Master/Vendor/EditVendor';
import ExpenseGroup from './components/pages/Accounting Master/Expense Group/ExpenseGroup';
import AddExpenseGroup from './components/pages/Accounting Master/Expense Group/AddExpenseGroup';
import EditExpenseGroup from './components/pages/Accounting Master/Expense Group/EditExpenseGroup';
import ExpenseItem from './components/pages/Accounting Master/Expense Item/ExpenseItem';
import AddExpenseItem from './components/pages/Accounting Master/Expense Item/AddExpenseItem';
import EditExpenseItem from './components/pages/Accounting Master/Expense Item/EditExpenseItem';
import OtherIncomeGroup from './components/pages/Accounting Master/Other Income Group/OtherIncomeGroup';
import AddOtherIncomeGroup from './components/pages/Accounting Master/Other Income Group/AddOtherIncomeGroup';
import EditOtherIncomeGroup from './components/pages/Accounting Master/Other Income Group/EditOtherIncomeGroup';
import OtherIncomeItem from './components/pages/Accounting Master/Other Income Item/OtherIncomeItem';
import AddOtherIncomeItem from './components/pages/Accounting Master/Other Income Item/AddOtherIncomeItem';
import EditOtherIncomeItem from './components/pages/Accounting Master/Other Income Item/EditOtherIncomeItem';
import Requisition from './components/pages/Purchase/Requisition/Requisition';
import SMSTemplate from './components/pages/Master/SMSTemplate/SMSTemplate';
import CertificateApproval from './components/pages/Certificate/Certificate Approval/CertificateApproval';
import SendSMS from './components/pages/SMS/Send SMS/sendSMS.js';
import SendEmail from './components/pages/Email/Send Email/SendEmail.js';
import SMSHistory from './components/pages/SMS/SMS History/SMSHistory.js';
import FeeGeneration from './components/pages/Payment/Fee Generation/FeeGeneration.js';
import FeeDeposit from './components/pages/Payment/Fee Deposit/FeeDeposit.js';
import FormDesign from './components/pages/Master/Form Design/FormDesign.js';
import EnquiryFollowUp from './components/pages/Enquiry/Enquiry Follow Up/EnquiryFollowUp.js';
import AdmissionReport from './components/pages/Report/Admisson Report/AdmissionReport.js';
import PaymentReport from './components/pages/Report/Payment Report/PaymentReport.js';
import StudentReport from './components/pages/Report/Student Report/StudentReport.js';
import AttendanceReport from './components/pages/Report/Attendance Report/AttendanceReport.js';
import EnquiryReport from './components/pages/Report/Enquiry Report/EnquiryReport.js';
import CertificateReport from './components/pages/Report/Certificate Report/CertificateReport.js';
import ShareRegistrationPage from './components/pages/Admission/Registration/ShareRegistrationPage.js';
import CourseTrackerReport from './components/pages/Report/Course Tracker Report/CourseTrackerReport.js';
import Category from './components/pages/Expense/Category/Category.js';
import ExpenseDetails from './components/pages/Expense/Expense Details/ExpenseDetails.js';
import BulkIDCard from './components/pages/Admission/Admission/BulkIdCard.js';
import { IdleTimerProvider } from './components/Login/IdleTimerContext.js';
import { PdfSettingsProvider } from './components/layouts/PdfSettingsContext.js';
import AddOrganization from './components/pages/Master/Organization/AddOrganization.js';
import AddBranch from './components/pages/Master/Branch/AddBranch.js';
import AddFormDesign from './components/pages/Master/Form Design/AddFormDesign.js';
import EditFormDesign from './components/pages/Master/Form Design/EditFormDesign.js';
import PaymentMode from './components/pages/Master/Payment mode/PaymentMode.js';
import EmployeeAttendance from './components/pages/Attendance/EmployeeAttendance.js';
import AddEmployeeAttendance from './components/pages/Attendance/AddEmployeeAttendance.js';
import BookIssueTransaction from './components/pages/Library/BookIssueTransaction.jsx';
import BookReservation from './components/pages/Library/BookReservation.jsx';
import ManageFine from './components/pages/Library/ManageFine.jsx';
import ExpenseApproval from './components/pages/Expense Management/ExpenseApproval.jsx';
import ExpenseReport from './components/pages/Expense Management/ExpenseReport.jsx';
import ExpenseEntry from './components/pages/Expense Management/ExpenseEntry.jsx';
import ExpenseCategory from './components/pages/Expense Management/ExpenseCategory.jsx';
import HRReports from './components/pages/Report/HR Report/HRReports.jsx';
import  Payroll from './components/pages/Hr management/Payroll.jsx';
import SalaryStructure from './components/pages/Hr management/SalaryStructure.jsx';

// import TeacherApp from "./TeacherPanel/src/App";

// ✅ Student Panel Import
// ✅ Correct (based on your folder structure)
// import StudentApp from "./StudentPanel/StudentApp";



import WaralsMainLayout from "./WaralsAdmin/src/layout/MainLayout";
import WaralsDashboard from "./WaralsAdmin/src/pages/Dashboard";
import FormModule from "./WaralsAdmin/src/pages/ExclusivePermission/FormModule";
import FormRegister from "./WaralsAdmin/src/pages/ExclusivePermission/FormRegister";

import WaralsUserGroup from "./WaralsAdmin/src/pages/CPanel/UserGroup";
import WaralsUser from "./WaralsAdmin/src/pages/CPanel/User";
import WaralsManageUser from "./WaralsAdmin/src/pages/CPanel/ManageUser";
import ManageClient from './WaralsAdmin/src/pages/CPanel/ManageClient.jsx';
import AddNewClient from './WaralsAdmin/src/pages/CPanel/AddNewClient.jsx';
import EditClient from './WaralsAdmin/src/pages/CPanel/EditClient.jsx';
import BookCategory from './components/pages/Library/BookCategory.jsx';
import BookMaster from './components/pages/Library/BookMaster.jsx';
import LibraryMember from './components/pages/Library/LibraryMember.jsx';
import LibraryReports from './components/pages/Report/Library report/LibraryReports.jsx';
import LeaveType from "./components/pages/Leave Management/LeaveType";
import LeaveBalance from "./components/pages/Leave Management/LeaveBalance";
import LeaveApplication from "./components/pages/Leave Management/LeaveApplication";
import StudentRoutes from './student-panel/src/routes/StudentRoutes.js';
import TeacherRoutes from './teacher-panel/src/routes/TeacherRoutes.js';
const AppRoutes = () => (
  <PdfSettingsProvider>
  <Routes>




    <Route path="/" element={<AccountEntry />} />
    <Route path="/login" element={<LoginPage />} />

    {/* Teacher Panel */}
    {/* <Route path="/teacher/*" element={<TeacherApp />} /> */}

    {/* ✅ Student Panel */}
    {/* <Route path="/student/*" element={<StudentApp />} /> */}

    <Route path="/warals" element={<WaralsMainLayout />}>
      <Route path="dashboard" element={<WaralsDashboard />} />
      <Route path="form-module" element={<FormModule />} />
      <Route path="form-register" element={<FormRegister />} />
      <Route path="user-group" element={<WaralsUserGroup />} />
      <Route path="user" element={<WaralsUser />} />
      <Route path="manage-user" element={<WaralsManageUser />} />
      <Route path="manage-client" element={<ManageClient />} />
      <Route path="/warals/manage-client/add-new-client" element={<AddNewClient />} />
      <Route path="/warals/manage-client/edit-client/:id" element={<EditClient />} />
    </Route>



{/* ======================================================== */}


    <Route path="/dashboard" element={<SideBar><Dashboard /></SideBar>} />
    
    {/* City */}
    <Route path="/city" element={<SideBar><City/></SideBar>} />
    <Route path="/add-city" element={<SideBar><AddCity/></SideBar>} />
    <Route path="/edit-city/:cityId" element={<SideBar><EditCity/></SideBar>} />

    {/* State  */}
    <Route path="/state" element={<SideBar><State/></SideBar>} />
    <Route path="/add-state" element={<SideBar><AddState/></SideBar>} />
    <Route path="/edit-state/:stateId" element={<SideBar><EditState/></SideBar>} />

     {/* Country */}
     <Route path="/country" element={<SideBar><Country/></SideBar>} />
    <Route path="/add-country" element={<SideBar><AddCountry/></SideBar>} />
    <Route path="/edit-country/:countryId" element={<SideBar><EditCountry/></SideBar>} />

    {/* Library */}
<Route  path="/library-management/book-category" element={<SideBar><BookCategory /></SideBar>}/>
<Route  path="/library-management/book-master" element={<SideBar><BookMaster /></SideBar>}/>
<Route  path="/library-management/library-member" element={<SideBar><LibraryMember /></SideBar>}/>
<Route  path="/library-management/book-issue-transaction" element={<SideBar><BookIssueTransaction /></SideBar>}/>
<Route  path="/library-management/book-reservation" element={<SideBar><BookReservation /></SideBar>}/>
<Route  path="/library-management/manage-fine" element={<SideBar><ManageFine /></SideBar>}/>
<Route  path="/report/library-report" element={<SideBar><LibraryReports/></SideBar>}/>

// LEAVE MANAGEMENT
<Route
  path="/leave-management/leave-type"
  element={
    <SideBar>
      <LeaveType />
    </SideBar>
  }
/>

<Route
  path="/leave-management/leave-balance"
  element={
    <SideBar>
      <LeaveBalance />
    </SideBar>
  }
/>

<Route
  path="/leave-management/leave-application"
  element={
    <SideBar>
      <LeaveApplication />
    </SideBar>
  }
/>

<Route
  path="/reports/hr-reports"
  element={
    <SideBar>
      <HRReports />
    </SideBar>
  }
/>

// HR MANAGEMENT

<Route
  path="hr/salary-structure"
  element={
    <SideBar>
      <SalaryStructure />
    </SideBar>
  }
/>

<Route
  path="/hr/payroll"
  element={
    <SideBar>
      <Payroll />
    </SideBar>
  }
/>
 {/* Payment Mode */}
     <Route path="/payment-mode" element={<SideBar><PaymentMode/></SideBar>} />

    {/* Department */}
    <Route path="/department" element={<SideBar><Department/></SideBar>} />
    <Route path="/add-department" element={<SideBar><AddDepartment/></SideBar>} />
    <Route path="/edit-department/:deptId" element={<SideBar><EditDepartment/></SideBar>} />

    {/* Designation */}
    <Route path="/designation" element={<SideBar><Designation/></SideBar>} />
    <Route path="/add-designation" element={<SideBar><AddDesignation/></SideBar>} />
    <Route path="/edit-designation/:desigId" element={<SideBar><EditDesignation/></SideBar>} />

    {/* Employee */}
    <Route path="/employee" element={<SideBar><Employee/></SideBar>} />
    <Route path="/employee-attendance" element={<SideBar><EmployeeAttendance/></SideBar>} />
    <Route path="/add-employee-attendance" element={<SideBar><AddEmployeeAttendance/></SideBar>} />
     <Route path="/add-employee" element={<SideBar><AddEmployee/></SideBar>} />
    <Route path="/edit-employee/:employeeID" element={<SideBar><EditEmployee/></SideBar>} />
   
    {/* Follow Up Medium */}
    <Route path="/follow-up-medium" element={<SideBar><FollowUpMedium/></SideBar>} />
    <Route path="/add-FollowUpMedium" element={<SideBar><AddFollowUpMedium/></SideBar>} />
    <Route path="/edit-FollowUpMedium/:FollowUpMediumId" element={<SideBar><EditFollowUpMedium/></SideBar>} />

    {/* Interest Level */}
    <Route path="/interest-level" element={<SideBar><InterestLevel/></SideBar>} />
    <Route path="/add-InterestLevel" element={<SideBar><AddInterestLevel/></SideBar>} />
    <Route path="/edit-InterestLevel/:InterestLevelId" element={<SideBar><EditInterestLevel/></SideBar>} />

    {/* Organization */}
    <Route path="/organization" element={<SideBar><Organization/></SideBar>} />
    <Route path="/edit-Organization/:OrganizationId" element={<SideBar><EditOrganization/></SideBar>} />
    <Route path="/add-Organization" element={<SideBar><AddOrganization/></SideBar>} />

    {/* Branch */}
     <Route path="/branch" element={<SideBar><Branch/></SideBar>} />
    <Route path="/edit-Branch/:BranchId" element={<SideBar><EditBranch/></SideBar>} />
    <Route path="/add-Branch" element={<SideBar><AddBranch/></SideBar>} />

    {/* Source */}
    <Route path="/source" element={<SideBar><Source/></SideBar>} />
    <Route path="/add-Source" element={<SideBar><AddSource/></SideBar>} />
    <Route path="/edit-Source/:SourceId" element={<SideBar><EditSource/></SideBar>} />

    {/* Course Question Map */}
    <Route path="/course-question-map" element={<SideBar><CourseQuestionMap/></SideBar>} />


    {/* Status */}
     <Route path="/status" element={<SideBar><Status/></SideBar>} />
    <Route path="/add-Status" element={<SideBar><AddStatus/></SideBar>} />
    <Route path="/edit-Status/:StatusId" element={<SideBar><EditStatus/></SideBar>} />

    {/* Nationality */}
    <Route path="/nationality" element={<SideBar><Nationality/></SideBar>} />
    <Route path="/add-Nationality" element={<SideBar><AddNationality/></SideBar>} />
    <Route path="/edit-Nationality/:NationalityId" element={<SideBar><EditNationality/></SideBar>} />

    {/* Mode of Delivery */}
    <Route path="/mode-of-delivery" element={<SideBar><ModeOfDelivery/></SideBar>} />
    <Route path="/add-mode-of-delivery" element={<SideBar><AddModeOfDelivery/></SideBar>} />
    <Route path="/edit-mode-of-delivery/:id" element={<SideBar><EditModeOfDelivery/></SideBar>} />

    {/* User */}
    <Route path="/user" element={<SideBar><User/></SideBar>} />
    <Route path="/add-User" element={<SideBar><AddUser/></SideBar>} />
    <Route path="/edit-User/:UserId" element={<SideBar><EditUser/></SideBar>} />
    <Route path="/edit-student-user/:UserId" element={<SideBar><EditUser/></SideBar>} />



    {/* User Group */}
    <Route path="/user-group" element={<SideBar><UserGroup/></SideBar>} />
    <Route path="/add-User-group" element={<SideBar><AddUserGroup/></SideBar>} />
    <Route path="/edit-User-group/:id" element={<SideBar><EditUserGroup/></SideBar>} />

    {/* Course */}
    <Route path="/course" element={<SideBar><Course/></SideBar>} />
    <Route path="/add-Course" element={<SideBar><AddCourse/></SideBar>} />
    <Route path="/edit-Course/:CourseId" element={<SideBar><EditCourse/></SideBar>} />

    {/* Module */}
    <Route path="/module" element={<SideBar><Module/></SideBar>} />
    <Route path="/add-module" element={<SideBar><Addmodule/></SideBar>} />
    <Route path="/edit-module/:ModuleId" element={<SideBar><EditModule/></SideBar>} />

    {/* Topic */}
    <Route path="/topic" element={<SideBar><Topic/></SideBar>} />
    <Route path="/add-topic" element={<SideBar><AddTopic/></SideBar>} />
    <Route path="/edit-topic/:id" element={<SideBar><EditTopic/></SideBar>} />

    {/* Course Tracker */}
     <Route path="/course-tracker" element={<SideBar><CourseTracker/></SideBar>} />

     {/* Course Mange */}
     <Route path="/course-manage" element={<SideBar><CourseManage/></SideBar>} />

    {/* Enquiry */}
    <Route path="/enquiry" element={<SideBar><Enquiry/></SideBar>} />
    <Route path="/add-enquiry" element={<SideBar><AddEnquiry/></SideBar>} />
    <Route path="/edit-enquiry/:enquiryId" element={<SideBar><EditEnquiry/></SideBar>} />


    {/* Client Details */}
    <Route path="/client-details" element={<SideBar><ClientDetails/></SideBar>} />
    <Route path="/add-client-details" element={<SideBar><AddClientDetails/></SideBar>} />
    <Route path="/edit-client-details/:clientId" element={<SideBar><EditClientDetails/></SideBar>} />

    {/* Enquiry Quotation */}
    <Route path="/enquiry-quotation" element={<SideBar><EnquiryQuotation/></SideBar>} />
    <Route path="/add-enquiry-quotation" element={<SideBar><AddEnquiryQuotation/></SideBar>} />
    <Route path="/edit-enquiry-quotation/:quotationId" element={<SideBar><EditEnquiryQuotation/></SideBar>} />

    {/* Batch */}
    <Route path="/batch" element={<SideBar><Batch/></SideBar>} />
    <Route path="/add-batch" element={<SideBar><AddBatch/></SideBar>} />
    <Route path="/edit-batch/:batchId" element={<SideBar><EditBatch/></SideBar>} />

    {/* Registration */}
    <Route path="/registration" element={<SideBar><Registration/></SideBar>} />
    <Route path="/add-registration" element={<SideBar><AddRegistration/></SideBar>} />
    <Route path="/edit-registration/:registrationId" element={<SideBar><EditRegistration/></SideBar>} />
   <Route path="/share-registration" element={<ShareRegistrationPage/>} />


    {/* Admission */}
    <Route path="/admission" element={<SideBar><Admission/></SideBar>} />
    <Route path="/add-admission" element={<SideBar><AddAdmission/></SideBar>} />
    <Route path="/edit-admission/:id" element={<SideBar><EditAdmission/></SideBar>} />
    <Route path="/bulk-id-card" element={<SideBar><BulkIDCard/></SideBar>} />

    {/* Student List  */}
    <Route path="/student-list" element={<SideBar><StudentList/></SideBar>} />
    <Route path="/view-student/:studentId" element={<SideBar><ViewStudentList/></SideBar>} />

    {/* View Assignment */}
    <Route path="/view-assignment" element={<SideBar><ViewAssignment/></SideBar>} />

    {/* Assignment */}
    <Route path="/create-assignment" element={<SideBar><Assignment/></SideBar>} />

<Route path="/student/*" element={<StudentRoutes />} />   
<Route path="/teacher/*" element={<TeacherRoutes />} />   


    {/* Question */}
    <Route path="/question" element={<SideBar><Question/></SideBar>} />
    <Route path="/add-question" element={<SideBar><AddQuestion/></SideBar>} />
    <Route path="/edit-question/:questionId" element={<SideBar><EditQuestion/></SideBar>} />

    {/* Manage Course Quiz */}
    <Route path="/manage-course-quiz" element={<SideBar><ManageCourseQuiz/></SideBar>} />
    <Route path="/add-managecoursequiz" element={<SideBar><AddManageCourseQuiz/></SideBar>} />
    <Route path="/edit-managecoursequiz/:quizId" element={<SideBar><EditManageCourseQuiz/></SideBar>} />

     {/* Manage Module Quiz */}
    <Route path="/manage-module-quiz" element={<SideBar><ManageModuleQuiz/></SideBar>} />
    <Route path="/add-ManageModuleQuiz" element={<SideBar><AddManageModuleQuiz/></SideBar>} />
    <Route path="/edit-ManageModuleQuiz/:quizId" element={<SideBar><EditManageModuleQuiz/></SideBar>} />

      {/* Manage Topic Quiz */}
    <Route path="/manage-topic-quiz" element={<SideBar><ManageTopicQuiz/></SideBar>} />
    <Route path="/add-ManageTopicQuiz" element={<SideBar><AddManageTopicQuiz/></SideBar>} />
    <Route path="/edit-ManageTopicQuiz/:quizId" element={<SideBar><EditManageTopicQuiz/></SideBar>} />

    {/* Quiz Result */}
    <Route path="/quiz-result" element={<SideBar><QuizResult/></SideBar>} />

    {/* Attendance */}
 <Route path="/student-attendance" element={<SideBar><Attendance/></SideBar>} />
<Route path="/add-student-attendance" element={<SideBar><AddAttendance/></SideBar>} />
<Route path="/edit-student-attendance/:id" element={<SideBar><EditAttendance /></SideBar>} />   {/* ← no SideBar */}
    {/* Dues List */}
    <Route path="/dues-list" element={<SideBar><DuesList/></SideBar>} />

    {/* Id Card */}
    <Route path="/id-card" element={<SideBar><IdCard/></SideBar>} />
    <Route path="/add-id-card" element={<SideBar><AddIdCard/></SideBar>} />
    <Route path="/edit-id-card/:id" element={<SideBar><EditIdCard/></SideBar>} />

    {/* Certificate */}
    <Route path="/certificate" element={<SideBar><Certificate/></SideBar>} />
    <Route path="/add-certificate" element={<SideBar><AddCertificate/></SideBar>} />
    <Route path="/edit-certificate/:certificateId" element={<SideBar><EditCertificate/></SideBar>} />

    {/* Certificate Issue */}
    <Route path="/certificate-issue" element={<SideBar><CertificateIssue/></SideBar>} />
    <Route path="/add-certificate-issue" element={<SideBar><AddCertificateIssue/></SideBar>} />
    <Route path="/edit-certificate-issue/:issueId" element={<SideBar><EditCertificateIssue/></SideBar>} />

    {/* Councellor Performance */}
    <Route path="/councellor-performance" element={<SideBar><CouncellorPerformance/></SideBar>} />

    {/* Trainer Performance */}
    <Route path="/trainer-performance" element={<SideBar><TrainerPerformance/></SideBar>} />

    {/* Sales Executive Performance */}
    <Route path="/sales-executive-performance" element={<SideBar><SalesExecutivePerformance/></SideBar>} />

    {/* Salary Head Type */}
    <Route path="/salary-head-type" element={<SideBar><SalaryHeadType/></SideBar>} />
    <Route path="/add-salary-head-type" element={<SideBar><AddSalaryHeadType/></SideBar>} />
    <Route path="/edit-salary-head-type/:salaryHeadTypeId" element={<SideBar><EditSalaryHeadType/></SideBar>} />

    {/* Salary Head Type */}
    <Route path="/salary-head" element={<SideBar><SalaryHead/></SideBar>} />
    <Route path="/add-salary-head" element={<SideBar><AddSalaryHead/></SideBar>} />
    <Route path="/edit-salary-head/:salaryHeadId" element={<SideBar><EditSalaryHead/></SideBar>} />

    {/* Salary Head Type */}
    <Route path="/leave-apply" element={<SideBar><LeaveApply/></SideBar>} />

    {/* Main Category */}
    <Route path="/main-category" element={<SideBar><MainCategory/></SideBar>} />
    <Route path="/add-main-category" element={<SideBar><AddMainCategory/></SideBar>} />
    <Route path="/edit-main-category/:mainCategoryId" element={<SideBar><EditMainCategory/></SideBar>} />

    {/* Sub Category */}
    <Route path="/sub-category" element={<SideBar><SubCategory/></SideBar>} />
    <Route path="/add-sub-category" element={<SideBar><AddSubCategory/></SideBar>} />
    <Route path="/edit-sub-category/:subCategoryId" element={<SideBar><EditSubCategory/></SideBar>} />

    {/* Brand */}
    <Route path="/brand" element={<SideBar><Brand/></SideBar>} />
    <Route path="/add-brand" element={<SideBar><AddBrand/></SideBar>} />
    <Route path="/edit-brand/:brandId" element={<SideBar><EditBrand/></SideBar>} />

    {/* Characteristics */}
    <Route path="/characteristics" element={<SideBar><Characteristics/></SideBar>} />
    <Route path="/add-characteristics" element={<SideBar><AddCharacteristics/></SideBar>} />
    <Route path="/edit-characteristics/:characteristicId" element={<SideBar><EditCharacteristics/></SideBar>} />

    {/* Product Master */}
    <Route path="/product-master" element={<SideBar><ProductMaster/></SideBar>} />
    <Route path="/add-product-master" element={<SideBar><AddProductMaster/></SideBar>} />
    <Route path="/edit-product-master/:productId" element={<SideBar><EditProductMaster/></SideBar>} />

    {/* Customer */}
    <Route path="/customer" element={<SideBar><Customer/></SideBar>} />
    <Route path="/add-customer" element={<SideBar><AddCustomer/></SideBar>} />
    <Route path="/edit-customer/:id" element={<SideBar><EditCustomer/></SideBar>} />

    {/* Vendor */}
    <Route path="/vendor" element={<SideBar><Vendor/></SideBar>} />
    <Route path="/add-vendor" element={<SideBar><AddVendor/></SideBar>} />
    <Route path="/edit-vendor/:id" element={<SideBar><EditVendor/></SideBar>} />

    {/* Expense Group */}
    <Route path="/expense-group" element={<SideBar><ExpenseGroup/></SideBar>} />
    <Route path="/add-expense-group" element={<SideBar><AddExpenseGroup/></SideBar>} />
    <Route path="/edit-expense-group/:id" element={<SideBar><EditExpenseGroup/></SideBar>} />

    {/* Expense Item */}
    <Route path="/expense-item" element={<SideBar><ExpenseItem/></SideBar>} />
    <Route path="/add-expense-item" element={<SideBar><AddExpenseItem/></SideBar>} />
    <Route path="/edit-expense-item/:expenseItemId" element={<SideBar><EditExpenseItem/></SideBar>} />

    {/* Other Income Group */}
    <Route path="/other-income-group" element={<SideBar><OtherIncomeGroup/></SideBar>} />
    <Route path="/add-other-income-group" element={<SideBar><AddOtherIncomeGroup/></SideBar>} />
    <Route path="/edit-other-income-group/:incomeGroupId" element={<SideBar><EditOtherIncomeGroup/></SideBar>} />

    {/* Other Income Item */}
    <Route path="/other-income-item" element={<SideBar><OtherIncomeItem/></SideBar>} />
    <Route path="/add-other-income-item" element={<SideBar><AddOtherIncomeItem/></SideBar>} />
    <Route path="/edit-other-income-item/:incomeItemId" element={<SideBar><EditOtherIncomeItem/></SideBar>} />

    {/* Requisition */}
    <Route path="/requisition" element={<SideBar><Requisition/></SideBar>} />
    <Route path="/add-other-income-item" element={<SideBar><AddOtherIncomeItem/></SideBar>} />
    <Route path="/edit-other-income-item/:incomeItemId" element={<SideBar><EditOtherIncomeItem/></SideBar>} />

      {/* SMS Template */}
    <Route path="/sms-template" element={<SideBar><SMSTemplate/></SideBar>} />

      {/* Certificate Approval */}
    <Route path="/certificate-approval" element={<SideBar><CertificateApproval/></SideBar>} />

      {/* Send SMS */}
    <Route path="/send-sms" element={<SideBar><SendSMS/></SideBar>} />

      {/* SMS History */}
    <Route path="/sms-history" element={<SideBar><SMSHistory/></SideBar>} />

      {/* Send Email */}
    <Route path="/send-email" element={<SideBar><SendEmail/></SideBar>} />

      {/* Fee Generation */}
    <Route path="/fee-generation" element={<SideBar><FeeGeneration/></SideBar>} />

      {/* Fee Deposit */}
    <Route path="/fee-deposit" element={<SideBar><FeeDeposit/></SideBar>} />

      {/* Form Design */}
    <Route path="/form-design" element={<SideBar><FormDesign/></SideBar>} />
    <Route path="/add-form-design" element={<SideBar><AddFormDesign/></SideBar>} />
    <Route path="/edit-form-design/:id" element={<SideBar><EditFormDesign/></SideBar>} />

      {/* Form Design */}
    <Route path="/enquiry-follow-up" element={<SideBar><EnquiryFollowUp/></SideBar>} />

      {/* Admission Report */}
    <Route path="/admission-report" element={<SideBar><AdmissionReport/></SideBar>} />

      {/* Payment Report */}
    <Route path="/payment-report" element={<SideBar><PaymentReport/></SideBar>} />

      {/* Student Report */}
    <Route path="/student-report" element={<SideBar><StudentReport/></SideBar>} />

      {/* Attendance Report */}
    <Route path="/attendance-report" element={<SideBar><AttendanceReport/></SideBar>} />

      {/* Enquiry Report */}
    <Route path="/enquiry-report" element={<SideBar><EnquiryReport/></SideBar>} />

      {/* Certificate Report */}
    <Route path="/certificate-report" element={<SideBar><CertificateReport/></SideBar>} />
    
      {/* Cours3 Tracker Report */}
    <Route path="/course-tracker-report" element={<SideBar><CourseTrackerReport/></SideBar>} />

      {/* Category */}
    <Route path="/category" element={<SideBar><Category/></SideBar>} />

      {/* Expense Details */}
    <Route path="/expense-details" element={<SideBar><ExpenseDetails/></SideBar>} />

{/* Expense Management  */}

<Route
  path="/expense-management/expense-category"
  element={
    <SideBar>
      <ExpenseCategory />
    </SideBar>
  }
/>

<Route
  path="/expense-management/expense-entry"
  element={
    <SideBar>
      <ExpenseEntry />
    </SideBar>
  }
/>

<Route
  path="/expense-management/expense-approval"
  element={
    <SideBar>
      <ExpenseApproval />
    </SideBar>
  }
/>

<Route
  path="/report/expense-report"
  element={
    <SideBar>
      <ExpenseReport />
    </SideBar>
  }
/>
    



  </Routes>
  </PdfSettingsProvider>
);

const AppWithIdleTimer = () => (
  <IdleTimerProvider>
    <AppRoutes />
  </IdleTimerProvider>
);

export default AppWithIdleTimer;